import { Injectable } from "@angular/core";
import {
  HttpHeaders,
  HttpResponse,
  HttpClient,
  HttpErrorResponse,
} from "@angular/common/http";
import { OktaAuthService } from "@okta/okta-angular";
import { UserActionService } from "./user-action.service";
import { OktaAuth } from "@okta/okta-auth-js";
import { MatDialog } from "@angular/material";
import { from, Observable, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class AuthService {
  signedInFlag: boolean;
  isAdmin: boolean = false;
  constructor(
    private http: HttpClient,
    private oktaAuthService: OktaAuthService,
    private userActionsService: UserActionService,
    private oktaAuth: OktaAuth,
    protected dialog: MatDialog
  ) {
    this.signedInFlag = false;
    this.isAdmin = false;
    localStorage["isUserRegistered"] = false;
  }

  public async logout() {
    try {
      // log it into user action history
      await this.userActionsService.recordUserActionAPI("Logout", null);
      localStorage["isUserRegistered"] = false;
      this.dialog.closeAll();
      this.oktaAuthService.logout();
      localStorage.clear();
      sessionStorage.clear();
    } catch (err) {
      console.error("Error during logout process:", err);
    }
  }

  public getOktaTokenExpirationTime() {
    const httpOptions: { headers: HttpHeaders; observe: "response" } = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      observe: "response"
    };

    const apiURL = environment.getAPI("getOktaTokenExpirationTime");
    return this.http.get<any>(apiURL, httpOptions);

  }

  async renewAccessToken() {
    try {
      // Retrieve the current access token
      const accessToken = await this.oktaAuth.tokenManager.get('accessToken');
      const idToken = await this.oktaAuth.tokenManager.get('idToken');

      if (!accessToken || !idToken) {
        return;
      }

      // Renew both access token and ID token
      const renewedTokens = await this.oktaAuth.token.renewTokens();

      if (renewedTokens.accessToken && renewedTokens.idToken) {

        // Set the new tokens in the token manager
        this.oktaAuth.tokenManager.setTokens({
          accessToken: renewedTokens.accessToken,
          idToken: renewedTokens.idToken,
        });

      } else {
        console.error('Failed to renew one or both tokens.');
      }

    } catch (err) {
      console.error('Error renewing tokens:', err);
    }
  } 

}
